
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: { StoryblokComponent },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.padding = this.getBreakpointValue(this.blok?.padding)
      styles.margin = this.getBreakpointValue(this.blok?.margin)
      styles.maxWidth = this.getBreakpointValue(
        this.blok?.width || 'xs-[300px]'
      )

      return styles
    },
    cardStyles() {
      const styles = {}

      if (this.blok?.templateColumns) {
        styles.display = 'grid'
        styles.gridTemplateColumns = this.buildGridTemplateColumns(
          this.getBreakpointValue(this.blok?.templateColumns)
        )
      }
      styles.height = this.blok.height || 'auto'
      styles.borderRadius = this.getBreakpointValue(this.blok?.borderRadius)
      styles.border = this.blok.border
      styles.background = this.blok?.backgroundColor

      return styles
    },
    bodyStyles() {
      return {
        padding: this.getBreakpointValue(this.blok.bodyPadding),
        margin: this.getBreakpointValue(this.blok.bodymargin),
      }
    },
    footerStyles() {
      return {
        padding: this.getBreakpointValue(this.blok.footerPadding),
        margin: this.getBreakpointValue(this.blok.footermargin),
      }
    },
  },
  methods: {
    buildGridTemplateColumns(sizes) {
      if (!sizes) return null

      const columnSizes = sizes
        .replace(/\s/g, '')
        .split(',')
        ?.reduce((acc, next) => {
          return acc + ` ${next}fr`
        }, '')
      return columnSizes
    },
  },
}
